jQuery(document).ready(function ($) {
    $("#navtoggle").click(function () {
        $('.mainnav').toggleClass("hidden");
        TweenMax.staggerFrom(".mainnav .menu-item", .5, { y: '-=30', opacity: 0, delay: 0.5, ease: Circ.easeOutIn }, 0.1);
    });

    $(".mainnav").click(function () {
        $(this).removeClass('visible').addClass('hidden');
    });

    $(".search-toggle").click(function () {
        $('.search-container').addClass('show');
        $("#search-input").focus();
    });

    $(".search-close").click(function () {
        $('.search-container').removeClass('show');
    });

    if ($(document).scrollTop() > 10) {
        $('body').addClass('scrolled');
    }

    $(document).on('scroll', function (event) {
        if ($(this).scrollTop() < 10) {
            $('body').removeClass('scrolled');
        } else {
            $('body').addClass('scrolled');
        }
    });
});
